import { defineStore } from 'pinia';

interface Params {
  codCheckList : number,
  checklist: number,
  codConcessionaria: number,
  codCheckListPai?: number | null
}

export const useAndamentoOficinaDigitalStore = defineStore('useAndamentoOficinaDigitalStore', {
  state: () => ({
    codCheckList : 0,
    checklist: 0,
    codConcessionaria: 0,
    codCheckListPai: null as number | null
  }),
  actions: {  
    setSelectedOrcamento(Params: Params) {
      this.codCheckList = Params.codCheckList
      this.checklist = Params.checklist
      this.codConcessionaria = Params.codConcessionaria
      this.codCheckListPai = Params.codCheckListPai ?? null
    }    
  },
  getters: {
    getOrcamento: (state) => {
      return {
        codCheckList : state.codCheckList,
        checklist : state.checklist,
        codConcessionaria : state.codConcessionaria,
        codCheckListPai : state.codCheckListPai
      }
    },
  },
});